import React, { useState, useEffect } from 'react';
import MaintenanceBanner from '../MaintenanceBanner/MaintenanceBanner';
import { useMaintenanceStatus } from '../../contexts/MaintenanceContext';
import styled from 'styled-components';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const ContentWrapper = styled.div<{ adjustMargin: boolean }>`
  margin-top: ${props => (props.adjustMargin ? '50px' : '0')};
  transition: margin-top 0.3s ease;
`;

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  const { isUnderMaintenance, maintenanceMessage } = useMaintenanceStatus();
  const [isBannerVisible, setIsBannerVisible] = useState(isUnderMaintenance);

  useEffect(() => {
    setIsBannerVisible(isUnderMaintenance);
  }, [isUnderMaintenance]);

  // This effect handles watching the banner's visibility
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => {
        const banner = document.querySelector('[data-testid="maintenance-banner"]');
        setIsBannerVisible(!!banner && window.getComputedStyle(banner).display !== 'none');
      });
    });

    const bannerElement = document.querySelector('[data-testid="maintenance-banner"]');
    if (bannerElement) {
      observer.observe(bannerElement, { attributes: true, childList: false, subtree: false });
    }

    return () => observer.disconnect();
  }, [isUnderMaintenance]);

  return (
    <>
      <MaintenanceBanner
        isVisible={isUnderMaintenance}
        message={maintenanceMessage}
        data-testid="maintenance-banner"
      />
      <ContentWrapper adjustMargin={isBannerVisible}>
        {children}
      </ContentWrapper>
    </>
  );
};

export default MaintenanceWrapper;

